import {validateNumber, validatePassingScore, validateRequired, validateRequiredIfNot} from "./ValidationFunctions";

const createTestTemplateConfig = {
  fields: {
    title: {
      type: 'text',
      label: 'Title',
      rules: [validateRequired('Test template titles')]
    },
    passing_score: {
      type: 'text',
      label: 'Passing percentage',
      rules: [validateRequired('Passing percentage'), validatePassingScore]
    },
    questions_displayed: {
      type: 'text',
      label: 'Questions displayed',
      rules: [validateRequired('Questions displayed'), validateNumber('Questions displayed')]
    },
    shuffle_questions: {
      type: 'boolean',
      defaultValue: true,
      label: 'Shuffle questions'
    },
    mode: {
      type: 'select',
      label: 'Mode',
      value: 'value',
      optionLabel: 'label',
      options: [
        {
          value: 'test',
          label: 'Test'
        },
        {
          value: 'quiz',
          label: 'Quiz'
        }
      ],
      rules: [validateRequired('Mode')]
    },
    subjective: {
      type: 'text',
      label: 'No. Subjective questions',
      rules: [validateRequiredIfNot('Subjective questions', 'questions_displayed')]
    },
    objective: {
      type: 'text',
      label: 'No. Objective questions',
      rules: [validateRequiredIfNot('Objective questions', 'questions_displayed')]
    },
    attempts: {
      type: 'text',
      label: 'Attempts',
      rules: [validateRequired('Attempts'), validateNumber('Attempts')]
    },
    duration: {
      type: 'text',
      label: 'Duration (minutes)',
      rules: [validateRequired('Duration'), validateNumber('Duration')]
    },
    allowTakerViewResults: {
      type: 'boolean',
      label: 'Allow taker to view the results',
    },
    allowTakerViewCorrectAnswer: {
      type: 'boolean',
      label: 'Allow taker to view the correct answers',
    },
    allowTakerChangeAnswerIfCorrectDisplayed: {
      type: 'boolean',
      label: 'Allow taker to change the answer',
    },
    showCorrectAnswerIfWrongSelected: {
      type: 'boolean',
      label: 'Show the correct answer if wrong is selected',
    },
  }
};

const questionAnswerConfig = {
  fields: {
    title: {
      type: 'text',
      label: 'Title',
      rules: [validateRequired('Test template titles')]
    },
    isCorrect: {
      type: 'boolean',
      label: 'Is correct',
    }
  }
};

export {
  createTestTemplateConfig,
  questionAnswerConfig
}
